import React from 'react';
import { getAttachmentType } from '@/datasets/attachments/helper';
import { ATTACHMENT_TYPE } from '@/datasets/attachments/constants';
import RequestAttachmentRow from './RequestAttachmentRow';

const RequestAttachmentRows = ({
  attachments,
  isRoot,
  columns,
  onCheckBoxClick,
  onFolderClick,
  theme,
}) => attachments.map((item) => (
  <RequestAttachmentRow
    columns={columns}
    isRoot={isRoot}
    item={item}
    key={`request_attachments_table_row_${item.id}`}
    onCheckBoxClick={onCheckBoxClick}
    onFolderClick={getAttachmentType(item) === ATTACHMENT_TYPE.folder ? onFolderClick : undefined}
    theme={theme}
  />
));

export default RequestAttachmentRows;
